module.exports = __webpack_public_path__ + "img/ok.2dbcfb19.png";